export default __webpack_public_path__ + "static/media/P200.732e5f5c.svg";